import React from 'react';

import ManualImportFileCell from '../../../components/file-uploads/ManualImportFileCell';
import { useUser } from '../../../hooks/useUser';

type RestrictedSkuFileCellProps = {
    logId: string;
    fileName: string;
    s3Key?: string | null;
};

function RestrictedSkuFileCell({
    logId,
    fileName,
    s3Key,
}: RestrictedSkuFileCellProps) {
    const { isAdmin, isSuperAdmin, isProcurementManager } = useUser();
    const canDownload = isAdmin || isSuperAdmin || isProcurementManager;

    return (
        <ManualImportFileCell
            logId={logId}
            fileName={fileName}
            s3Key={s3Key}
            canDownload={canDownload}
        />
    );
}

export default RestrictedSkuFileCell;
